<template>
  <div class="app-container">
    <div class="register-container">
      <pang-title :text="$router.lang.get('會員 註冊')" eng="Sign up" />
      <template v-if="emailVerifying">
        <div class="email-img-container">
          <img src="../../assets/images/img_tips_email_success.png" />
        </div>
        <div class="email-msg-container">
          {{
            $router.lang.get("已發送驗證碼到 {email} 信箱", { email: email })
          }}
        </div>
        <div class="email-hint-container">
          <div>
            {{ $router.lang.get("請立即前往，以便完成加入會員操作！") }}
          </div>
        </div>
        <div class="email-sms-container">
          <pang-sms-email
            ref="emailCode"
            :hint="$router.lang.get('驗證碼為 6 位數字')"
            v-model:value="emailCode"
            :email="email"
            :onBlur="codeValidator"
            :onEnter="submit"
          />
        </div>
        <div class="email-submit-hint" @click="showEmailHint">
          {{ $router.lang.get("還沒有收到驗證信件？") }}
        </div>
        <div class="email-submit-container">
          <button class="submit" @click="submit()">
            {{ $router.lang.get("確認") }}
          </button>
        </div>
        <div class="link-container">
          <div @click="goback">{{ $router.lang.get("修改信箱地址") }}</div>
          <div @click="gobackPhone">{{ $router.lang.get("手機號碼註冊") }}</div>
        </div>
      </template>
      <template v-else>
        <div class="info">
          <div>{{ $router.lang.get("歡迎加入panggame! ") }}</div>
          <div>
            {{ $router.lang.get("爲使用遊戲，請按照以下的格式進行註冊流程。") }}
          </div>
          <div>{{ $router.lang.get("完成註冊，即刻獲得上市祝福禮包！") }}</div>
        </div>
        <div class="login-form">
          <div class="input-container">
            <pang-tab :tabs="tabs" v-model:current="currentTab" />
          </div>
          <div v-if="currentTab == 0" class="input-container">
            <pang-sms-input
              buttMsgField="buttMsg4"
              buttMsgCountingField="buttMsgCounting4"
              ref="sms"
              :hint="$router.lang.get('请输入手机号，不为 0 开头的')"
              v-model:areacode="areacode"
              v-model:phone="phone"
              v-model:code="code"
              :validate="usePhone ? phoneAndUsernameValidator : phoneValidator"
              @enter="nextInput(usePhone ? $refs.password : $refs.username)"
            />
          </div>
          <div v-else class="input-container">
            <pang-input
              :placeholder="$router.lang.get('您的信箱地址')"
              ref="email"
              required
              v-model:value="email"
              name="email"
              :validate="emailValidator"
              @enter="submit"
            />
          </div>
          <div class="checkbox-container checkbox-middle">
            <input type="checkbox" v-model="usePhone" />
            <label @click="checkboxChange('usePhone')">{{
              $router.lang.get(
                "同時使用 {field} 作為登入賬號，取消勾選可自訂登入賬號",
                {
                  field:
                    currentTab == 0
                      ? $router.lang.get("手機號碼")
                      : $router.lang.get("信箱"),
                }
              )
            }}</label>
          </div>
          <div v-if="!usePhone" class="input-container">
            <pang-input
              :placeholder="$router.lang.get('請輸入自訂賬號')"
              ref="username"
              required
              :hint="
                $router.lang.get('賬號第一位必須為英文字母，最多 32 個字元')
              "
              v-model:value="username"
              name="username"
              :validate="usernameValidator"
              @enter="nextInput($refs.password)"
            />
          </div>
          <div class="input-container">
            <pang-input
              :placeholder="$router.lang.get('密碼')"
              ref="password"
              required
              :hint="$router.lang.get('密碼最少 8 個字元')"
              v-model:value="password"
              name="password"
              type="password"
              :validate="passwordValidator"
              @enter="nextInput($refs.password2)"
            />
          </div>
          <div class="input-container">
            <pang-input
              :placeholder="$router.lang.get('確認密碼')"
              ref="password2"
              required
              v-model:value="password2"
              name="password2"
              :validate="password2Validator"
              type="password"
              @enter="nextInput(currentTab == 1 ? $refs.email : null)"
            />
          </div>
          <div class="checkbox-container">
            <input type="checkbox" v-model="terms" />
            <label @click="checkboxChange('terms')"
              >{{ $router.lang.get("同意接受 ")
              }}<span
                class="link"
                @click.stop="openLink('/customerservice/terms')"
                >{{ $router.lang.get("《會員服務條款》") }}</span
              >，<span
                class="link"
                @click.stop="openLink('/customerservice/privacy')"
                >{{ $router.lang.get("《個人隱私條款》") }}</span
              ></label
            >
          </div>
          <div class="checkbox-container">
            <input type="checkbox" v-model="ads" />
            <label @click="checkboxChange('ads')">{{
              $router.lang.get("同意接受 Panggame 消息及廣告訊息")
            }}</label>
          </div>
          <div class="button-container">
            <button class="submit" @click="submit()">
              {{ $router.lang.get("確認") }}
            </button>
          </div>
        </div>
      </template>
    </div>
    <pang-dialog
      v-if="emailHintShow"
      :title="$router.lang.get('還沒有收到驗證信件？')"
      :cancelText="$router.lang.get('取消')"
      :submitText="$router.lang.get('確認')"
      @cancel="hintCancel"
      @submit="hintCancel"
    >
      <div>
        <ol>
          <li>
            <p>
              {{ $router.lang.get("網路會有一定延遲，請等幾分鐘後再去看看。") }}
            </p>
          </li>
          <li>
            <p>
              {{
                $router.lang.get(
                  "可能被信箱過濾，請到廣告信件、垃圾信件或者相關信件歸檔中查看。"
                )
              }}
            </p>
          </li>
          <li>
            <p>
              {{
                $router.lang.get(
                  "請確認一下Email地址是否拼寫錯誤，您可以用正確的信箱地址重新註冊。"
                )
              }}
            </p>
          </li>
          <li>
            <p>
              {{ $router.lang.get("您可以嘗試再次發送。")
              }}<span class="dialog-link" @click="emailResent">{{
                $router.lang.get("點擊再次發送")
              }}</span>
            </p>
          </li>
          <li>
            <div>
              {{ $router.lang.get("實在不行，沒關係，請聯係我們的客服。") }}
            </div>
            <div>
              {{ $router.lang.get("客服信箱：pangtwmhcs@panggame.com") }}
            </div>
            <div>
              {{ $router.lang.get("FB私訊：")
              }}<a
                target="_blank"
                class="dialog-link"
                href="https://www.facebook.com/smhtw2020/"
                >{{ $router.lang.get("點擊跳轉到FB主頁") }}</a
              >
            </div>
          </li>
        </ol>
      </div>
    </pang-dialog>
  </div>
</template>

<script>
import { useScreenState } from "../../store";
import {
  PangInput,
  PangTab,
  PangSmsInput,
  PangSmsEmail,
  PangTitle,
  PangDialog,
} from "../../components";
import request from "../../api/request";
import validate from "../../utils/validate";
import { pwHash } from "../../utils";
import message from "../../utils/message";
import browser from '../../utils/browser';
import Cookies from 'js-cookie'

export default {
  name: "Register",
  components: {
    PangInput,
    PangTab,
    PangSmsInput,
    PangSmsEmail,
    PangTitle,
    PangDialog,
  },
  data() {
    return {
      screenState: useScreenState(),
      tabs: [
        this.$router.lang.get("手機註冊"),
        this.$router.lang.get("信箱註冊"),
      ],
      currentTab: 0,
      nickname: "",
      username: "",
      password: "",
      password2: "",
      areacode: "66",
      phone: "",
      usePhone: true,
      code: "",
      email: "",
      emailCode: "",
      terms: false,
      ads: false,
      usernameValidator: validate.usernameRegister,
      codeValidator: validate.code,
      emailValidator: validate.emailRegister,
      phoneValidator: validate.phoneRegister,
      phoneAndUsernameValidator: validate.phoneAndUsernameRegister,
      emailVerifying: false,
      emailHintShow: false,
    };
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    async submit() {
      let validated = true;
      if (!this.emailVerifying) {
        let val1 = true;
        if (!this.usePhone) {
          val1 = await this.$refs.username.validateValue(this.username);
        }
        let val2 = await this.$refs.password.validateValue(this.password);
        let val3 = await this.$refs.password2.validateValue(this.password2);
        let val4 = true;
        if (this.currentTab == 0) {
          val4 = await this.$refs.sms.validateValue();
        } else {
          val4 = await this.$refs.email.validateValue(this.email);
        }
        validated = val1 && val2 && val3 && val4;
      }
      else {
        validated = await this.$refs.emailCode.validateValue(this.emailCode);
      }
      if (validated) {
        if (this.terms) {
          if (this.currentTab == 1 && !this.emailVerifying) {
            this.emailVerifying = true;
            let _this = this;
            setTimeout(function () {
              _this.$refs.emailCode.getCode();
            }, 500);
          } else {
            let password = pwHash(this.password);
            let _this = this;
            let data = {
              username: this.username,
              password: password,
              utm_source: this.$route.query.utm_source?(
                  Array.isArray(this.$route.query.utm_source)?
                  this.$route.query.utm_source[0]:
                    this.$route.query.utm_source
                  ):Cookies.get('utm_source'),
              utm_campaign: this.$route.query.utm_campaign?(
                  Array.isArray(this.$route.query.utm_campaign)?
                  this.$route.query.utm_campaign[0]:
                    this.$route.query.utm_campaign
                  ):Cookies.get('utm_campaign'),
              utm_medium: this.$route.query.utm_medium?(
                  Array.isArray(this.$route.query.utm_medium)?
                  this.$route.query.utm_medium[0]:
                    this.$route.query.utm_medium
                  ):Cookies.get('utm_medium'),
              ads: this.ads,
            };
            if (this.currentTab == 0) {
              data.areacode = this.areacode;
              data.phone = this.phone.replace(/^0/, '');
              data.code = this.code;
              if (this.usePhone) data.username = data.phone;
              if (data.ads) data.ads_phone = data.ads;
            } else {
              if (this.usePhone) data.username = this.email;
              data.email = this.email;
              data.code = this.emailCode;
            }
            request.post("/register", data, this).then(function (res) {
              if (res.status == 200) {
                _this.screenState.token = res.data.data.tk;
                _this.screenState.user = res.data.user;
                window.localStorage.setItem("token", res.data.data.tk);
                window.localStorage.setItem(
                  "user_info",
                  JSON.stringify(res.data.user)
                );
                window.fbq("track", "CompleteRegistration", {
                  value: 1.0,
                  currency: "USD",
                });
                window.gtag("event", "SignupCompleted");
                window.gtag("event", "conversion", {
                  send_to: "AW-482543440/lrJSCLrhseYBENCOjOYB",
                });
                _this.$router.replace("/account/success");
              } else {
                message.resMessage(res, _this);
              }
            });
          }
        } else {
          message.showMessage(
            this,
            this.$router.lang.get("請勾選同意接受條款")
          );
        }
      }
    },
    goback() {
      this.emailVerifying = false;
      this.currentTab = 1;
    },
    gobackPhone() {
      this.emailVerifying = false;
      this.currentTab = 0;
    },
    checkboxChange(name) {
      this[name] = !this[name];
    },
    openLink(url) {
        if (browser.isPc)
            window.open(url)
        else
            this.$router.push(url)
    },
    nextInput(next) {
      if (next) next.focus();
      else this.submit();
    },
    showEmailHint() {
      this.emailHintShow = true;
    },
    emailResent() {
      this.$refs.emailCode.getCode();
      this.emailHintShow = false;
    },
    hintCancel() {
      this.emailHintShow = false;
    },
    passwordValidator() {
      let res = validate.password(this.password);
      if (res) return res;
      if (this.password2) 
        this.$refs.password2.validateValue(this.password2);
    },
    password2Validator() {
      if (!this.password2)
        return this.$router.lang.get("請確認密碼");
      if (!this.password)
        this.$refs.password.validateValue(this.password);
      else if (this.password2 != this.password)
        return this.$router.lang.get("兩次輸入的密碼並不相符，請重新輸入");
    },
  },
  beforeMount() {
    if (this.screenState.user) {
      this.$router.replace("/account");
    }
  },
};
</script>

<style>
.register-container .pang-tab > div {
  max-width: 160px;
  width: 30.27vw;
}
</style>

<style scoped>
.register-container {
  height: 100%;
  color: #666666;
  padding-bottom: 44px;
}

.login-title {
  width: 90vw;
  max-width: 640px;
  margin: 29px auto;
  text-align: center;
}

.login-title > div:first-child {
  font-size: 52px;

  font-weight: normal;
  color: #c6a86c;
}

.login-title span {
  font-size: 21px;

  font-weight: normal;
  color: #b4b6b9;
  margin: 0 12px;
}

.info {
  width: 90vw;
  max-width: 640px;
  margin: 31px auto;
}

.info > div {
  font-size: 18px;

  font-weight: normal;
  color: #939393;
  line-height: 30px;
}
.info > div:last-child, .info > div:first-child {
  color: #c6a86c;
}

.login-form {
  width: 90vw;
  max-width: 640px;
  margin: 31px auto;
}

.input-container {
  margin-bottom: 21px;
}

.button-container {
  margin-top: 30px;
}

.checkbox-container {
  margin: 27px 0;
  display: flex;
}

.checkbox-middle {
  margin-top: -10px;
}

.checkbox-container > label {
  cursor: pointer;
  line-height: 30px;
  height: 60px;
  display: inline-block;
  margin: 3px 20px;
}

.link-container {
  display: flex;
  margin-top: 23px;
  height: 97px;
}

.link-container > div {
  margin: auto 0;
  padding: 0 67px;
  line-height: 35px;
  height: 35px;
  border-left: 1px solid #b4b4b4;
  cursor: pointer;
}

.link-container > div:first-child {
  margin-left: auto;
  border-left: none;
}

.link-container > div:last-child {
  margin-right: auto;
}

.link {
  color: #7a8dff;
}

.email-img-container {
  width: 129px;
  margin: 67px auto 44px auto;
}

.email-img-container > img {
  width: 129px;
  height: 99px;
}

.email-msg-container,
.email-hint-container,
.email-sms-container,
.email-submit-container {
  margin: 0 auto;
  max-width: 900px;
  width: 90vw;
  text-align: center;
}

.email-msg-container {
  font-size: 24px;
  color: #333333;
  margin-bottom: 26px;
}

.email-hint-container {
  font-size: 18px;

  font-weight: normal;
  color: #939393;
  line-height: 30px;
  margin-bottom: 54px;
}

.email-sms-container {
  max-width: 373px;
  margin-bottom: 42px;
}

.email-submit-container {
  max-width: 235px;
  margin-bottom: 42px;
}

.email-submit-hint {
  text-align: center;
  max-width: 235px;
  margin: auto;
  margin-bottom: 14px;
  color: #7a8dff;
  cursor: pointer;
}

.dialog-link {
  color: #7a8dff;
  cursor: pointer;
  text-decoration: none;
}
</style>